/* eslint-disable max-lines */
import styled from 'styled-components';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import Link from '@base/Link/Link';
import MenusNav from '@base/MenusNav/MenusNav';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import { menus } from '@utils/constants';
import { Fonts, TextColors, Spacings } from '@styles/index';

const Left = styled.div`
  grid-column: 1/6;
  position: fixed;
  @media (max-width: 768px) {
    display: none;
  }
`;
const Right = styled.div`
  grid-column: 6/25;
  @media (max-width: 768px) {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const TermsContainer = styled.div`
  li {
    font-weight: ${Fonts.REGULAR};
    font-size: ${Fonts.P1};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: ${TextColors.BLACK};
  }
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const tableData = [
  { label: 'A. About Unacademy', id: 'about' },
  { label: 'B. Unacademy Platform', id: 'platform' },
  { label: 'C. Unacademy Accounts', id: 'accounts' },
  {
    label: 'D. Access, Permissions and Restrictions',
    id: 'access'
  },
  {
    label: 'E. Content Use',
    id: 'content_use'
  },
  {
    label: 'F. Content and Conduct',
    id: 'content_conduct'
  },
  { label: 'G. Unacademy Plus - Subscription', id: 'plus_subscription' },
  {
    label: 'H. Unacademy Intellectual Property Right',
    id: 'property_right'
  },
  { label: 'I. Refunds', id: 'refunds' },
  { label: 'J. Electronic Communication', id: 'electronic_communication' },
  { label: 'K. Termination of Account', id: 'termination_of_account' },
  { label: 'L. Effective of Termination', id: 'effective_of_termination' },
  { label: 'M. Copyright Infringement', id: 'copyright_infringement' },
  {
    label: 'N. Confidentiality',
    id: 'confidentiality'
  },
  { label: 'O. Disclaimer', id: 'disclaimer' },
  { label: 'P. Limitation of Liability', id: 'limitation_of_liablity' },
  { label: 'Q. Indemnity', id: 'indemnity' },
  {
    label: 'R. Eligibility to use and Acceptance of the Terms and Conditions',
    id: 'eligibility'
  },
  { label: 'S. Force Majeure', id: 'force_majeure' },
  { label: 'T. Information Technology Act', id: 'information_technology_act' },
  { label: 'U. Other Laws', id: 'other_laws' },
  { label: 'V. Governing Law and Jurisdiction', id: 'governing_laws' },
  { label: 'W. Modification, Amendment or Termination', id: 'modification' },
  { label: 'X. General', id: 'general' },
  { label: 'Y. Refund Policy', id: 'refund_policy' }
];

const Terms = () => {
  const router = useRouter();
  const { pathname, query } = router;

  return (
    <>
      <Left>
        <MenusNav data={menus} currentHref={pathname} />
      </Left>

      <Right>
        <TermsWrapper>
          <TermsContainer>
            {query.in_app !== 'true' && <H2>Terms and Conditions</H2>}
            <br />
            <br />
            <ContentsTable data={tableData} />
            <P1>
              <strong />
              <br />
            </P1>
            <P1>As updated on January 29, 2019</P1>
            <P1>
              <br />
            </P1>
            <P1>
              Welcome to the Unacademy’s terms and condition. These terms and
              conditions (“Terms and Conditions”), are between Unacademy and
              you, (hereinafter referred to as “You” or “Your” or “User(s)”). By
              accessing our website
              <Link
                href="/"
                as="/"
                anchorStyle={`margin: ${Spacings.SPACING_1B}; color: ${TextColors.BLUE};`}
              >
                www.unacademy.com
              </Link>
              (“Website”) and/or our app ‘Unacademy Educate’ and/or ‘Unacademy
              Learners’ (“Apps”), Website and Apps together shall be referred to
              as “Unacademy Platform”, you agree to be bound by the provisions
              of these Terms and Conditions.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              Please read these Terms and Conditions, along with the Privacy
              Policy and all other rules and policies made available or
              published on Unacademy Platform as they shall govern your use of
              the Unacademy Platform. By using or visiting the Unacademy
              Platform or any Unacademy software, data feeds, and service
              provided to you on, from, or through the Unacademy Platform, you
              signify your agreement to (1) these “Terms and Conditions”, (2)
              Unacademy’s Privacy Policy and any other terms that are updated
              from time to time. If you do not agree to any of these terms,
              please do not use the Unacademy Platform.
            </P1>
            <br />
            <br />

            <a name="about">
              <StyledH3>A. About Unacademy</StyledH3>
            </a>

            <P1>
              <br />
            </P1>
            <P1>
              {`The domain name, Website and the Apps are owned, registered and
          operated by Sorting Hat Technologies Private Limited, a private
          company incorporated under the (Indian) Companies Act, 2013, and
          having its registered office at Maruthi Infotech Centre, 3
          ${(
            <sup>rd</sup>
          )} Floor, A-Block, Domlur, Koramangala Inner Ring Road,
          Bangalore 560 071, Karnataka, India, (hereinafter referred to as
          “Unacademy” or “ us” or “we” or “our” or “Company”).`}
            </P1>

            <br />
            <br />

            <a name="platform">
              <StyledH3>B. Unacademy Platform</StyledH3>
            </a>
            <ol>
              <li>
                These Terms and Conditions apply to all Users of the Unacademy
                Platform, including educators who are also contributors of User
                Content on the Unacademy Platform. The Unacademy Platform
                includes all aspects of the Website and Apps which includes but
                is not limited to products, software and service offered via the
                Unacademy Platform, such as the Unacademy online platform,
                Unacademy Plus - Subscription, Unacademy Bytes and any other
                service or application that Unacademy introduces from time to
                time.
              </li>
              <li>
                Unacademy Platform is an online platform that supports and
                facilitates the online creation of educational videos/or
                tutorials, by the Users of the Unacademy Platform and acts as an
                intermediary between the educator and the User. A User may
                create a video, audio clip or tutorial, by using the Unacademy
                Platform. Such content uploaded through the use of the Unacademy
                Platform shall hereinafter be referred to as “User Content”. You
                agree and acknowledge that Unacademy has no control over and
                assumes no responsibility for, the User Content and by using the
                Unacademy Platform, you expressly relieve Unacademy from any and
                all liability arising from the User Content.
              </li>
              <li>
                The Unacademy Platform may include or contain links to any
                third-party websites that may or may not be owned or controlled
                by Unacademy. Unacademy has no control over, and assumes no
                responsibility for, the content, privacy policies, or practices
                of any third-party websites. In addition, Unacademy will not and
                cannot censor or edit the content of any third-party site. By
                using the Unacademy Platform, you expressly relieve Unacademy
                from any and all liability arising from your use of any
                third-party website or services. However, we recommend that
                before you use any third-party services or website you read and
                understand the terms and conditions and privacy policy of each
                such website that you visit.
              </li>
              <li>
                Subject to these Terms and Conditions, Privacy Policy and all
                other other rules and policies made available or published
                elsewhere, Unacademy hereby grants the you a non-exclusive,
                non-transferable, non-sublicensable, limited license to use the
                Unacademy Platform in accordance with these Terms and
                Conditions.
              </li>
              <li>
                You agree and acknowledge that Unacademy shall have the right at
                any time to change or discontinue any aspect or feature of the
                Unacademy Platform, including, but not limited to, the User
                Content, hours of availability and equipment needed for access
                or use. Further, Unacademy may discontinue disseminating any
                portion of information or category of information may change or
                eliminate any transmission method and may change transmission
                speeds or other signal characteristics. Unacademy reserves the
                right to refuse access to the Unacademy Platform, terminate
                Accounts, remove or edit contents without any notice to You.
              </li>
            </ol>

            <br />
            <br />
            <a name="accounts">
              <StyledH3>C. Unacademy Accounts</StyledH3>
            </a>

            <P1>
              In order to access some of the features of the Unacademy Platform,
              you may have to create your account with Unacademy. You agree and
              confirm that you will never use another User’s account nor provide
              access to your account to any third-party. When creating your
              account, you confirm that the information so provided is accurate
              and complete. Further, you agree that you are solely responsible
              for the activities that occur on your account, and you shall keep
              your account password secure and not share the same with anyone.
              You must notify Unacademy immediately of any breach of security or
              unauthorized use of your account. At no point in time will
              Unacademy be liable for any losses caused by any unauthorized use
              of your account, you shall solely be liable for the losses caused
              to Unacademy or others due to such unauthorized use, if any.
            </P1>
            <P1>
              Unacademy takes no responsibility for any User Content that is
              uploaded on the Unacademy Platform, and further, the User shall be
              solely responsible for his or her own actions in utilizing such
              User Content and availing the Unacademy Platform provided herein.
            </P1>

            <br />
            <br />

            <a name="access">
              <StyledH3>D. Access, Permissions and Restrictions</StyledH3>
            </a>
            <P1>
              Unacademy hereby grants you permission to access and use the
              Unacademy Platform as set forth in these Terms and Conditions,
              provided that:
            </P1>
            <ol>
              <li>
                You agree not to distribute in any medium any part of the
                Unacademy Platform or the content without Unacademy’s prior
                written authorization.
              </li>
              <li>
                You agree not to alter or modify any part of the Unacademy
                Platform.
              </li>
              <li>
                You agree not to access content of any other User through any
                technology or means other than the video playback pages of the
                Unacademy Platform itself.
              </li>
              <li>
                You agree not to use the Unacademy Platform for any of the
                following commercial uses unless you obtain Unacademy’s prior
                written approval:
              </li>
            </ol>
            <ul>
              <li>the sale of access to the Unacademy Platform;</li>
              <li>
                the sale of advertising, sponsorships, or promotions placed on
                or within the Unacademy Platform or content; or
              </li>
              <li>
                the sale of advertising, sponsorships, or promotions on any page
                or website that provide similar Unacademy Platform as that of
                Unacademy.
              </li>
            </ul>
            <ol>
              <li>
                You agree to receive installs and updates from time to time from
                Unacademy. These updates are designed to improve, enhance and
                further develop the Unacademy Platform and may take the form of
                bug fixes, enhanced functions, new software modules and
                completely new versions. You agree to receive such updates (and
                permit Unacademy to deliver these to you) as part of your use of
                the Unacademy Platform.
              </li>
              <li>
                You agree not to use or launch any automated system, including
                without limitation, “robots,” “spiders,” or “offline readers,”
                that accesses the Unacademy Platform in a manner that sends more
                request messages to Unacademy’s servers in a given period of
                time than a human can reasonably produce in the same period by
                using a conventional on-line web browser. Notwithstanding the
                foregoing, Unacademy grants the operators of public search
                engines permission to use spiders to copy materials from the
                site for the sole purpose of and solely to the extent necessary
                for creating publicly available searchable indices of the
                materials, but not caches or archives of such materials.
                Unacademy reserves the right to revoke these exceptions either
                generally or in specific cases at any time with or without
                providing any notice in this regard. You agree not to collect or
                harvest any personally identifiable information, including
                account names, from the Unacademy Platform, nor to use the
                communication systems provided by the Unacademy Platform (e.g.,
                comments, email) for any commercial solicitation purposes. You
                agree not to solicit, for commercial purposes, any Users of the
                Unacademy Platform with respect to User Content.
              </li>
              <li>
                You may post reviews, comments and other content; send other
                communications; and submit suggestions, ideas, comments,
                questions or other information as long as the content is not
                illegal, obscene, threatening, defamatory, invasive of privacy,
                infringement of intellectual property rights, or otherwise
                injurious to third parties or objectionable and does not consist
                of or contain software viruses, political campaigning,
                commercial solicitation, chain letters, mass mailings or any
                other form of spam. Further, you give Unacademy limited, royalty
                free, worldwide, non-exclusive license to use the User Content
                and communication in developing its Unacademy Platform and in
                any of its marketing or promotional activities.
              </li>
              <li>
                In your use of the Unacademy Platform, you will at all times
                comply with all applicable laws and regulations.
              </li>
              <li>
                Unacademy reserves the right to discontinue any aspect of the
                Unacademy Platform at any time with or without notice at its
                sole discretion.
              </li>
            </ol>
            <br />
            <br />

            <a name="content_use">
              <StyledH3>E. Content Use</StyledH3>
            </a>
            <P1>
              In addition to the general restrictions mentioned above, the
              following limitation and conditions shall apply to your use of the
              Content.
            </P1>
            <ol>
              <li>
                Unacademy Content utilized on the Unacademy Platform which shall
                include but not be limited to trademarks, service marks and
                logos (“Marks”), process, images, software, graphics are owned
                by or licensed to Unacademy and subject to copyright and other
                intellectual property rights under the law.
              </li>
              <li>
                User Content is provided to you on an AS IS basis. You may
                access Content for your information and personal use solely as
                intended through the provided functionality on the Unacademy
                Platform and as permitted under these Terms and Conditions. You
                shall not download any User Content unless you see a “download”
                or similar link displayed by Unacademy on the Unacademy Platform
                for that User Content. You shall not copy, reproduce, make
                available online or electronically transmit, publish, adapt,
                distribute, transmit, broadcast, display, sell, license, or
                otherwise exploit any User Content for any other purposes other
                than as provided herein without the prior written consent of
                Unacademy or the respective licensors of the User Content.
                Unacademy and its licensors reserve all rights not expressly
                granted in and to the Unacademy Platform and the User Content.
              </li>
              <li>
                You agree not to circumvent, disable or otherwise interfere with
                security-related features of the Unacademy Platform or features
                that prevent or restrict use or copying of any User Content or
                enforce limitations on use of the Unacademy Platform or the User
                Content therein.
              </li>
              <li>
                You understand that when using the Unacademy Platform, you will
                be exposed to User Content from variety of sources and by
                different Users, and that Unacademy is not responsible for the
                accuracy, usefulness, safety, or intellectual property rights of
                or relating to such User Content. You further understand and
                acknowledge that you may be exposed to User Content that is
                inaccurate, offensive, indecent, or objectionable, and you agree
                to waive, and hereby do waive, any legal or equitable rights or
                remedies you have or may have against Unacademy with respect
                thereto, and, to the extent permitted by applicable law, agree
                to indemnify and hold harmless Unacademy, its owners, operators,
                affiliates, licensors, and licensees to the fullest extent
                allowed by law regarding all matters related to your use of the
                Unacademy Platform.
              </li>
            </ol>

            <br />
            <br />

            <a name="content_conduct">
              <StyledH3>F. Content and Conduct</StyledH3>
            </a>
            <ol>
              <li>
                As an Unacademy User, you may submit User Content on the
                Unacademy Platform, including videos and User comments. You
                understand that Unacademy does not guarantee any confidentiality
                with respect to any User Content you submit.
              </li>
              <li>
                You shall be solely responsible for your own User Content and
                the consequences of submitting and publishing such User Content
                on the Unacademy Platform. You affirm, represent, and warrant
                that you own or have the necessary licenses, rights, consents,
                and permissions to publish the User Content that you submit; and
                you grant limited license to Unacademy to all patent, trademark,
                trade secret, copyright or other proprietary rights in and to
                such User Content for publication on the Unacademy Platform
                pursuant to these Terms and Conditions for the duration the said
                User Content is available on Unacademy Platform.
              </li>
              <li>
                For clarity, you retain your ownership rights in your User
                Content. However, by submitting User Content to Unacademy, you
                hereby grant Unacademy a limited, worldwide, non-exclusive,
                royalty-free, sub-licenseable and transferable license to use,
                reproduce, distribute, display, publish, make available online
                or electronically transmit, the User Content in connection with
                the Unacademy Platform and Unacademy’s (and its successors’ and
                affiliates’) business, including without limitation for
                promoting and redistributing part or all of the Unacademy
                Platform in any media formats and through any media channels.
                You also hereby grant each User of the Unacademy Platform a
                limited, non-exclusive license to access your User Content
                through the Unacademy Platform. The above licenses granted by
                you in the User Content you submit to the Unacademy Platform
                terminate within a commercially reasonable time after you
                request Unacademy to remove or delete your videos from the
                Unacademy Platform provided you pay the mutually agreed amount
                that Unacademy incurred in providing the Unacademy Platform to
                you. You understand and agree, however, that Unacademy may
                retain, but not display, distribute, or perform, server copies
                of your videos that have been removed or deleted. The above
                licenses granted by you in User comments and testimonial you
                submit are perpetual and irrevocable.
              </li>
              <li>
                You further agree that User Content you submit on the Unacademy
                Platform will not contain third party copyrighted material, or
                material that is subject to other third party proprietary
                rights, unless you have permission from the rightful owner of
                the material or you are otherwise legally entitled to post the
                material and to grant Unacademy all of the license rights
                granted herein.
              </li>
              <li>
                Furthermore, you confirm that the User Content uploaded by you
                is not:
              </li>
              <ol>
                <li>False, inaccurate or misleading;</li>
                <li>
                  Infringe any third party’s copyright, patent, trademark, trade
                  secret or other proprietary rights or rights of publicity or
                  privacy;
                </li>
                <li>Violate any law, statue, ordinance or regulation;</li>
                <li>
                  defamatory, unlawfully threatening or unlawfully harassing;
                </li>
                <li>obscene or contain pornography.</li>
                <li>
                  Contain any viruses, trojan horses, worms, cancelbots or other
                  computer programming routines that may damage, detrimentally
                  interfere with, surreptitiously intercept or expropriate any
                  system, data or personal information.
                </li>
              </ol>
              <li>
                You understand and confirm that you shall not during your use of
                the Unacademy Platforms at any time post or publish any content,
                comments or act in any way which will amount to harassment of
                any other User, whether a learner or an educator. If at any
                given point it comes to the notice of Unacademy that you are
                engaged in any kind of harassment of other Users, then in such a
                case you agree that Unacademy shall have the sole right to
                suspend/terminate your account with immediate effect and without
                any notice of such suspension or termination and we also reserve
                the right in our sole discretion to initiate any legal
                proceedings against you in such cases.
              </li>
              <li>
                Unacademy at its sole discretion may process any audio or
                audio-visual content uploaded by you to the Unacademy Platform
                to confirm if the same is in accordance with the Unacademy
                internal quality requirements and is compatible with the
                Unacademy Platform.
              </li>
              <li>
                Unacademy does not endorse any User Content submitted on the
                Unacademy Platform by any User or other licensor, or any
                opinion, recommendation, or advice expressed therein, and
                Unacademy expressly disclaims any and all liability in
                connection with User Content. Unacademy does not permit
                copyright infringing activities and infringement of intellectual
                property rights on the Unacademy Platform, and Unacademy will
                remove all User Content if properly notified that such Content
                infringes on another’s intellectual property rights. Unacademy
                reserves the right to remove User Content without prior notice
                if it has reason to believe that the User Content infringes any
                copyright.
              </li>
            </ol>
            <br />
            <br />

            <a name="plus_subscription">
              <StyledH3>G. Unacademy Plus - Subscription</StyledH3>
            </a>
            <P1>
              Please refer to Unacademy Plus – Subscription terms and conditions
              to know more about the terms that shall govern your subscription.
              Unacademy Plus – Subscription is exclusive for the Users who have
              subscribed. You shall not give any unauthorized access or
              distribute or reproduce the Educational Content (as defined in the
              Subscription terms and conditions) to a third party.
            </P1>
            <P1>
              In the event that Unacademy becomes aware of any Users giving
              unauthorized access to any third party or distributing or
              reproducing any Educational Content to or any third-party channel
              or media, Unacademy reserves the right to suspend or terminate the
              said User’s account with immediate effect.
            </P1>

            <br />
            <br />

            <a name="property_right">
              <StyledH3>H. Unacademy Intellectual Property Right</StyledH3>
            </a>
            <P1>
              The Unacademy Platform, the processes, and their selection and
              arrangement, including but not limited to all text, graphics, User
              interfaces, visual interfaces, sounds and music (if any), artwork
              and computer code on the Unacademy Platform is owned and
              controlled by Unacademy and the design, structure, selection,
              coordination, expression, look and feel and arrangement of such
              content mentioned hereinabove is protected by copyright, patent
              and trademark laws, and various other national and international
              IPR laws and regulations. For clarity, content in the above
              sentence shall not include User Content.
            </P1>
            <P1>
              Unless otherwise indicated or anything contained to the contrary,
              or any proprietary material owned by a third-party and so
              expressly mentioned, Unacademy owns all IPR to and into the
              trademark “UNACADEMY”, “UNACADEMY PLUS” and the Unacademy
              Platform.
            </P1>
            <P1>
              The mark “ Unacademy” is the sole property of Unacademy.
              Reproduction in whole or in part of the same is strictly
              prohibited unless used with an express written permission from
              Unacademy.
            </P1>
            <br />
            <br />

            <a name="refunds">
              <StyledH3>I. Refunds</StyledH3>
            </a>
            <P1>
              Any refunds that are to be processed shall be processed in
              accordance with Unacademy’s refund policy.
            </P1>
            <br />
            <br />

            <a name="electronic_communication">
              <StyledH3>J. Electronic Communication</StyledH3>
            </a>
            <P1>
              When you visit Unacademy Platform or send email to us, you are
              communicating with us electronically. By communicating with us,
              you consent to receive communication from us electronically. We
              will communicate with you by email or posting notices on Unacademy
              Platform. You agree that all agreements, notices, disclosures,
              disclaimers, offers and other communications that are provided to
              you electronically satisfy any legal requirement that such
              communication should be in writing.
            </P1>
            <br />
            <br />

            <a name="termination_of_account">
              <StyledH3>K. Termination of Account</StyledH3>
            </a>
            <ol>
              <li>
                Unacademy will terminate a Users access to the Unacademy
                Platform, if
              </li>
              <ol>
                <li>the User is a repeat copyright infringer;</li>
                <li>
                  the Users breaches any terms of these Terms and Conditions.
                </li>
                <li>Violation of any applicable laws;</li>
                <li>
                  your use of the Unacademy Platform disrupts our business
                  operations or affects any other party/ User; or
                </li>
                <li>
                  you have behaved in a way, which objectively could be regarded
                  as inappropriate or unlawful or illegal or which would bring
                  any claims against Unacademy.
                </li>
              </ol>
              <li>
                Unacademy reserves the right to decide whether User Content
                violates these Terms and Conditions for reasons other than
                copyright infringement, such as, but not limited to,
                pornography, obscenity, or excessive length or any other
                parameter that Unacademy deems fit from time to time. Unacademy
                may at any time, without prior notice and in its sole
                discretion, remove such User Content and/or terminate a
                User&apos;s account for submitting such material in violation of
                these Terms and Conditions.
              </li>
              <li>
                We may suspend access to the Unacademy Platforms or require You
                to change Your password if we reasonably believe that the
                Unacademy Platforms have been or are likely to be misused, and
                we will notify You accordingly. Any termination of Your
                registration and/or Account or the Unacademy Platforms will not
                affect liability previously incurred by You.
              </li>
            </ol>
            <br />
            <br />

            <a name="effective_of_termination">
              <StyledH3>L. Effective of Termination</StyledH3>
            </a>
            <P1>
              In case any of the above-mentioned cases occur, Unacademy reserves
              the right, in its sole discretion, to terminate or suspend the
              User’s account with immediate effect. Upon suspension or
              termination of the User’s account:
            </P1>
            <ol>
              <li>
                Unacademy shall at its sole discretion withhold or stop any and
                all payments that are to be made to such User and evaluate the
                pay-outs. Payments shall only be made for all legitimate work
                that is not subject matter of any violation or dispute.
              </li>
              <li>
                Payments shall not be made for the work that is the subject
                matter of any of the breaches.
              </li>
              <li>
                User access shall be terminated immediately, and the User shall
                not be able to access the said terminated account.
              </li>
            </ol>
            <br />
            <br />

            <a name="copyright_infringement">
              <StyledH3>M. Copyright Infringement</StyledH3>
            </a>
            <ol>
              <li>
                Unacademy operates a clear copyright policy in relation to any
                User Content alleged to infringe the copyright of a third party.
              </li>
              <li>
                As part of Unacademy&apos;s copyright policy, Unacademy will
                terminate User access to the Unacademy Platform if a User has
                been determined to be a repeat infringer. A repeat infringer is
                a User who has been notified of infringing activity more than
                twice.
              </li>
              <li>
                If you believe that your work has been copied in a way that
                constitutes copyright infringement, please refer to the
                instructions given in the copyright policy on how to make a
                claim of copyright infringement.
              </li>
              <P1>
                <br />
              </P1>
              <li>Notice of Copyright Infringement:</li>
              <P1>
                <br />
              </P1>
              <ol>
                <li>
                  Pursuant to provisions of the Indian Copyright Act, 1952 read
                  with the Information Technology Act of 2000, we an
                  intermediary, allow general public to post content on our
                  platform. We have implemented procedures for receiving written
                  notification of claimed infringements on the User Content
                  uploaded on Unacademy Platform. We have also designated an
                  agent to receive notices of claimed copyright infringement. If
                  you believe in good faith that your copyright has been
                  infringed, you may provide us with a written communication
                  which contains:
                </li>
                <ol>
                  <li>
                    An electronic or physical signature of the person authorized
                    to act on behalf of the owner of the copyright interest;
                  </li>
                  <li>
                    A description of the copyrighted work that you claim has
                    been infringed upon;
                  </li>
                  <li>
                    A description of where the material that you claim is
                    infringing is located on the Unacademy Platform, including
                    the educator name, topic and any other detail identifying
                    the infringing content;
                  </li>
                  <li>
                    Your email address, your physical address and telephone
                    number;
                  </li>
                  <li>
                    A statement by you that you have a good faith belief that
                    the disputed use is not authorized by the copyright owner,
                    its agent, or the law; and
                  </li>
                  <li>
                    A statement by you, made under penalty of perjury, that the
                    information in your notice is accurate and that you are the
                    copyright owner or authorized to act on the copyright
                    owner’s behalf.
                  </li>
                </ol>
              </ol>
            </ol>
            <br />
            <P1>
              Please submit your notice to our Copyright Agent as follows:
            </P1>
            <br />
            <P1>
              Email us at
              <a href="mailto:legal@unacademy.com"> legal@unacademy.com</a>
            </P1>
            <br />
            <P1>Or contact us by mail at:</P1>
            <br />
            <P1>
              Unacademy
              <br />
              ATTN: Grievance Officer - Ms. Denise Gardner (CC: Legal
              Department)
            </P1>
            <P1>Sorting Hat Technologies Private Limited</P1>
            <P1>Maruthi Infotech Centre, 3rd Floor, A-Block,</P1>
            <P1>Domlur, Koramangala Inner Ring Road,</P1>
            <P1>Bangalore- 560 071</P1>
            <br />
            <ol>
              <li>Our policy to deal with Copyright infringements:</li>
            </ol>
            <P1>
              We follow a 3-strike policy- Three instances brought to our notice
              that are provided with all required supporting information will
              lead to the educator getting banned from the Unacademy Platform.
              His/her right to any and all compensation or monetary benefit that
              he/she might be eligible for shall be revoked. The detailed
              process is as under:
            </P1>
            <ol>
              <ol>
                <li>
                  First case of violation- The infringing User Content is taken
                  down and educator is given a warning and is suspended for a
                  week from making any new courses.
                </li>
                <li>
                  Second case of violation- The educator is suspended from
                  making any more videos on the Unacademy Platform for a month
                  and all User Content that amount to copyright violations are
                  brought down immediately.
                </li>
                <li>
                  Third violation- The educator is banned from the Unacademy
                  Platform and will be unable to make any more courses in the
                  future.
                </li>
              </ol>
            </ol>
            <br />
            <br />

            <a name="confidentiality">
              <StyledH3>N. Confidentiality</StyledH3>
            </a>
            <P1>
              <br />
            </P1>
            <P1>
              You will not without obtaining prior written consent of Unacademy,
              disclose to third party any Confidential Information (as defined
              below) that is disclosed to you during the term of your use of the
              Unacademy Platform.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              For the purpose of this clause Confidential Information shall
              include but shall not be limited to employee details, User list,
              business model, processes, ideas, concepts etc. relating to
              Unacademy or Unacademy Platform which are not available in the
              public domain. You acknowledge and agree that the Confidential
              Information so provided to you shall at all time be the property
              of Unacademy and any breach of the same shall cause irreparable
              damage to us.
            </P1>
            <br />
            <br />

            <a name="disclaimer">
              <StyledH3>O. Disclaimer</StyledH3>
            </a>
            <P1>
              YOU AGREE THAT YOUR USE OF THE UNACADEMY PLATFORM SHALL BE AT YOUR
              SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, UNACADEMY, ITS
              OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS EXCLUDE ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE UNACADEMY PLATFORM AND
              YOUR USE THEREOF. TO THE FULLEST EXTENT PERMITTED BY LAW,
              UNACADEMY EXCLUDES ALL WARRANTIES, CONDITIONS, TERMS OR
              REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE USER
              CONTENT OR THE CONTENT OF ANY SITES SO LINKED AND ASSUMES NO
              LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS, MISTAKES, OR
              INACCURACIES OF USER CONTENT OR ANY CONTENT ON UNACADEMY, (II)
              PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
              RESULTING FROM YOUR ACCESS TO AND USE OF THE UNACADEMY PLATFORM,
              (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
              AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL
              INFORMATION STORED THEREIN, (IV) ANY INTERRUPTION OR CESSATION OF
              TRANSMISSION TO OR FROM THE UNACADEMY PLATFORM, (IV) ANY BUGS,
              VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
              THROUGH THE UNACADEMY PLATFORM BY ANY THIRD PARTY, AND/OR (V) ANY
              ERRORS OR OMISSIONS IN ANY USER CONTENT OR ANY OTHER CONTENT OR
              FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE
              OF ANY USER CONTENT OR ANY OTHER CONTENT THAT IS POSTED, EMAILED,
              TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE UNACADEMY
              PLATFORM. UNACADEMY DOES NOT WARRANT, ENDORSE, GUARANTEE, OR
              ASSUME RESPONSIBILITY FOR ANY USER CONTENT OR UNACADEMY PLATFORM
              ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE UNACADEMY
              PLATFORM OR ANY HYPERLINKED SERVICES OR FEATURED IN ANY BANNER OR
              OTHER ADVERTISING, AND UNACADEMY WILL NOT BE A PARTY TO OR IN ANY
              WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND
              THIRD-PARTY PROVIDERS OF USER CONTENT OR SERVICES. AS WITH THE
              PURCHASE OF A SUBSCRIPTION OR SERVICE THROUGH ANY MEDIUM OR IN ANY
              ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE
              CAUTION WHERE APPROPRIATE.
            </P1>
            <br />
            <br />

            <a name="limitation_of_liablity">
              <StyledH3>P. Limitation of Liability</StyledH3>
            </a>
            <P1>
              TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL
              UNACADEMY, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE
              LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
              PUNITIVE, LOSSES OR EXPENSES OR CONSEQUENTIAL DAMAGES WHATSOEVER
              RESULTING FROM ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF USER
              CONTENT OR ANY OTHER CONTENT AVAILABLE AT UNACADEMY, (II) PERSONAL
              INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING
              FROM YOUR ACCESS TO AND USE OF OUR UNACADEMY PLATFORMS, (III) ANY
              UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
              ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
              THEREIN, (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
              FROM THE UNACADEMY PLATFORM, (IV) ANY BUGS, VIRUSES, TROJAN
              HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH OUR
              UNACADEMY PLATFORMS BY ANY THIRD PARTY, AND/OR (V) ANY ERRORS OR
              OMISSIONS IN ANY USER CONTENT OR ANY OTHER CONTENT OR FOR ANY LOSS
              OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF ANY
              CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE
              VIA THE UNACADEMY PLATFORM, WHETHER BASED ON WARRANTY, CONTRACT,
              TORT, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT UNACADEMY IS
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              WE UNDERSTAND THAT, IN SOME JURISDICTIONS, WARRANTIES, DISCLAIMERS
              AND CONDITIONS MAY APPLY THAT CANNOT BE LEGALLY EXCLUDED, IF THAT
              IS TRUE IN YOUR JURISDICTION, THEN TO THE EXTENT PERMITTED BY LAW,
              UNACADEMY LIMITS ITS LIABILITY FOR ANY CLAIMS UNDER THOSE
              WARRANTIES OR CONDITIONS TO EITHER SUPPLYING YOU THE UNACADEMY
              PLATFORMS AGAIN.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              YOU SPECIFICALLY ACKNOWLEDGE THAT UNACADEMY SHALL NOT BE LIABLE
              FOR USER CONTENT OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT
              OF ANY THIRD PARTY AND THAT THE RISK OF HARM OR DAMAGE FROM THE
              FOREGOING RESTS ENTIRELY WITH YOU.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              THE UNACADEMY PLATFORM IS CONTROLLED AND OFFERED BY UNACADEMY FROM
              ITS FACILITIES IN INDIA. UNACADEMY MAKES NO REPRESENTATIONS THAT
              THE UNACADEMY PLATFORM IS APPROPRIATE OR AVAILABLE FOR USE IN
              OTHER LOCATIONS. THOSE WHO ACCESS OR USE THE UNACADEMY PLATFORM
              FROM OTHER JURISDICTIONS DO SO AT THEIR OWN VOLITION AND ARE
              RESPONSIBLE FOR COMPLIANCE WITH LOCAL LAW.
            </P1>
            <br />
            <br />

            <a name="indemnity">
              <StyledH3>Q. Indemnity</StyledH3>
            </a>
            <P1>
              To the extent permitted by applicable law, you agree to defend,
              indemnify and hold harmless Unacademy, its parent corporation,
              officers, directors, employees and agents, from and against any
              and all claims, damages, obligations, losses, liabilities, costs
              or debt, and expenses (including but not limited to
              attorney&apos;s fees) arising from: (i) your use of and access to
              the Unacademy Platform; (ii) your violation of any term of these
              Terms and Conditions; (iii) your violation of any third party
              right, including without limitation any copyright, property, or
              privacy right; (iv) any claim that your User Content caused damage
              to a third party; or (v) violation of any applicable laws. This
              defence and indemnification obligation will survive these Terms
              and Conditions and your use of the Unacademy Platform.
            </P1>
            <br />
            <br />

            <a name="eligibility">
              <StyledH3>
                R. Eligibility to use and Acceptance of the Terms and Conditions
              </StyledH3>
            </a>
            <P1>
              You affirm that you are either more than 18 years of age, or
              possess legal parental or guardian consent, and are fully able and
              competent to enter into the terms, conditions, obligations,
              affirmations, representations, and warranties set forth in these
              Terms and Conditions, and to abide by and comply with these Terms
              and Conditions. If you are under 18 years of age, then please talk
              to your parents or guardian before using the Unacademy Platform.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              Unacademy reserves the right to refuse access to use the Unacademy
              Platforms to any Users or to suspend and/or terminate access
              granted to existing registered Users at any time without according
              any reasons for doing so.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              We provide these Terms and Conditions with our Unacademy Platform
              so that you know what terms apply to your use. You acknowledge
              that we have given you a reasonable opportunity to review these
              Terms and Conditions and that you have agreed to them. You agree
              and acknowledge that your use of the Unacademy Platform is subject
              to the most current version of the Terms and Conditions made
              available on the Unacademy Platform at the time of such use.
            </P1>
            <br />
            <br />

            <a name="force_majeure">
              <StyledH3>S. Force Majeure</StyledH3>
            </a>
            <P1>
              Unacademy shall not be liable for failure to perform, or the delay
              in performance of, any of its obligations if, and to the extent
              that, such failure or delay is caused by events substantially
              beyond the its control, including but not limited to acts of God,
              acts of the public enemy or governmental body in its sovereign or
              contractual capacity, war, terrorism, floods, fire, strikes,
              epidemics, civil unrest or riots, power outage, and/or unusually
              severe weather.
            </P1>
            <br />
            <br />

            <a name="information_technology_act">
              <StyledH3>T. Information Technology Act</StyledH3>
            </a>
            <P1>
              These Terms and Conditions are published in accordance with the
              provisions of Rule 3 (1) of the Information Technology
              (Intermediaries guidelines) Rules, 2011 that require publishing
              the rules and regulations, privacy policy and terms and conditions
              for access or usage of the Unacademy Platform.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              You are advised not to post any information or messages that are,
              or that may be construed, as being malicious , defamatory,
              inappropriate, slanderous, pornographic or otherwise sexually
              oriented or that makes attacks on or the otherwise opines or
              comments on any individuals or groups of individuals, educational
              institutions or any other entities whatsoever (whether companies,
              firms, or any other institutions). You also agree not to post any
              information to which you do not have copyrights or other
              appropriate permissions to post in public forum. Your failure to
              comply with these terms may result in removal of your postings
              without prior notice to User. The IP address of all posts is
              recorded to aid in enforcing these conditions.
            </P1>
            <br />
            <br />

            <a name="other_laws">
              <StyledH3>U. Other Laws</StyledH3>
            </a>
            <P1>
              Certain laws require to maintain data with respect to the
              Unacademy Platform and other personal information in a prescribed
              format and Unacademy will use all the information to the extent
              required in compliance with the applicable laws and as may be
              directed or amended from time to time.
            </P1>
            <br />
            <br />

            <a name="governing_laws">
              <StyledH3>V. Governing Law and Jurisdiction</StyledH3>
            </a>
            <P1>
              The Terms and Conditions are governed by and constructed in
              accordance with the laws of India, without reference to conflict
              of laws principles and you irrevocably and unconditionally submit
              to the exclusive jurisdiction of the courts located in Bangalore,
              Karnataka, India.
            </P1>
            <br />
            <br />

            <a name="modification">
              <StyledH3>W. Modification, Amendment or Termination</StyledH3>
            </a>
            <P1>
              Unacademy may, in its sole discretion, modify or revise these
              Terms and Conditions and policies at any time, and you agree to be
              bound by such modifications or revisions. Your continued use of
              the Unacademy Platform post any modification of the Terms and
              Conditions shall be taken as your consent and acceptance to such
              modifications. Nothing in these Terms and Conditions shall be
              deemed to confer any third-party rights or benefits.
            </P1>
            <br />
            <br />

            <a name="general">
              <StyledH3>X. General</StyledH3>
            </a>
            <P1>
              If any part of these Terms and Conditions is unlawful, void or
              unenforceable, that part of will be deemed severable and will not
              affect the validity and enforceability of any remaining
              provisions. Any notice required to be given in connection with the
              Unacademy Platform shall be in writing and sent to the registered
              office of Unacademy. We do not guarantee continuous, uninterrupted
              or secure access to the Unacademy Platform, and operation of the
              Unacademy Platform may be interfered by numerous factors outside
              our control. Headings are for reference purpose only an on no way
              define, limit, construe or describe the scope or extent of such
              section. Out failure to act with respect to any breach by you or
              others does not waive our right to act with respect to subsequent
              or similar breaches.
            </P1>
            <br />
            <br />

            <a name="refund_policy">
              <StyledH3>Y. Refund Policy</StyledH3>
            </a>
            <P1>
              Please read the subscription terms and conditions carefully before
              subscribing to any of the subscription plans, as once you have
              subscribed you cannot change, cancel your subscription plan. Once
              you subscribe and make the required payment, it shall be final and
              there cannot be any changes or modifications to the same and
              neither will there be any refund.
            </P1>
            <br />
            <br />
          </TermsContainer>
        </TermsWrapper>
      </Right>
    </>
  );
};

Terms.pageInfo = {
  name: 'Unacademy Terms',
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default Terms;
